import request from "@/utils/request";

/** 根据cognito取得的sub查询会员 */
export async function getMember(sub) {
    return request({
        url: '/home/member/' + sub,
        method: 'get'
    })
}

/** 增加会员 */
export async function postMember(member) {
    return request({
        url: '/home/member',
        method: 'post',
        data: member
    })
}

/** 查询所有语言列表 */
export async function getLanguages() {
    return request({
        url: '/home/language',
        method: 'get'
    })
}

/** 根据语言码和会员sub查询所有课程列表 */
export async function getCourses(langCode, sub) {
    return request({
        url: '/home/' + langCode + '/member/' + sub,
        method: 'get'
    })
}

/** 购买课程成功后，按购买课程件数批量增加会员课程关联表 */
export async function postMemberCourses(memberCourses, orderId) {
    const payload = memberCourses.map(item => ({
        ...item,
        orderId, // ✅ 每个课程都附带订单号
    }));
    return request({
        url: '/home/memberCourse',
        method: 'post',
        data: payload
    })
}

/** 查询所有走马灯列表 */
export async function getCarousels() {
    return request({
        url: '/home/carousel',
        method: 'get'
    })
}


